var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _dec23, _dec24, _dec25, _dec26, _dec27, _dec28, _dec29, _dec30, _dec31, _dec32, _dec33, _dec34, _dec35, _dec36, _dec37, _dec38, _dec39, _dec40, _dec41, _dec42, _dec43, _dec44, _dec45, _dec46, _dec47, _dec48, _dec49, _dec50, _dec51, _dec52, _dec53, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

/**
 * @copyright
 * Copyright(c) 2020 SICK AG
 */
import { Component, Event, html, Prop, State, Watch } from '@sick-davinci/ce-decorators';
import { style } from './Plotter.style';
import * as QuickChart from '@meistercharts/meistercharts';
import { ColoredDataElement } from '../_utils/ColoredDataElement.js'; // should be imported first, so css variables from theme-base are available

import { CssTools } from '../_utils/CssTools.js';
import { resolveCssColor } from '../_utils/ColorTools.js';
import { ArrayTools } from '../_utils/ArrayTools.js';
import { ValueAxisBuilder } from '../_utils/ValueAxisBuilder.js';
import { TimeAxisBuilder } from '../_utils/TimeAxisBuilder.js';
import { ThemeService } from '../_utils/ThemeService.js';
import { createValueFormat, createValueFormatMinMax } from '../_utils/ValueFormat.js';
import { defaultShorthandLabels } from '../_utils/NumberFormatter.js';
import { createTooltipDecimalsBoxStyles, createTooltipEnumsBoxStyles, createTooltipFont } from '../_utils/TooltipTools.js';
import { sanitizeSamples, sanitizeSamplingPeriod, validateEnumLabels, validateExpectedSamplingPeriod, validateVisibleTimeRange } from './PlotterValidation.js';
import { computeActiveLegendItemIndices, createLegendColors, createLegendLabels, createLegendTypes, createLegendState, createLegendSymbols, getDecimalDataSeriesCount, getEnumDataSeriesCount } from './PlotterTools.js';
import { computeDecimalDataSeriesFromSample, computeDecimalDataSeriesStyles, computeEnumDataSeries, computeEnumDataSeriesStyles, computeLineStyles } from './PlotterConversion.js';
import { PlotterToolbar, PlotterToolbarButton } from './PlotterToolbar.js';
import { LegendGrid } from '../legend/LegendGrid.js';
import { PlotterInfoPopup } from './PlotterInfoPopup.js';
/**
 * A high-performance time-based line chart (similar to an oszilloscope).
 * Handle fast data input with various data-series, each having an own y-axis.
 * Users can navigate back and forth in time as well as zoom into important time-frames.
 * All data is passed through the `addSample` function instead of a property because data is managed by this element itself in a high performance manner.
 *
 * Plotter scaling can be changed using mouse-scroll + CTRL/SHIFT keys.
 *
 * Please have look at {@link expectedSamplingPeriod} which is crucial for the behavior and performance of this chart.
 *
 * @example
 * ```
 * <davinci-element-container heading="Plotter" style="width: 500px; height: 300px">
 *   <davinci-plotter id="plotter" visible-value-axes="[0, 1, 2]" stop data-series-configs='[
                   { "valueRange": { "start": 0, "end": 10 }, "lineColor": 0 },
                   { "valueRange": { "start": -10, "end": 10 }, "lineColor": 1 },
                   { "valueRange": { "start": 0, "end": 50 }, "lineColor": 2 }
                 ]'></davinci-plotter>
 * </davinci-element-container>
 * <script>
 *  const plotter = document.getElementById('plotter');
 *  plotter.addSamples(
 *    {timestamp: Date.now()-2000, values:[0,0,0]},
 *    {timestamp: Date.now()-1000, values:[5, 50,500]},
 *    {timestamp: Date.now(), values:[10,100,1000]}
 * );
 * </script>
 * ```
 */

export let Plotter = (_dec = Component({
  tag: 'davinci-plotter',
  style,
  dependencies: [LegendGrid, PlotterToolbar, PlotterInfoPopup]
}), _dec2 = Prop(), _dec3 = Reflect.metadata("design:type", Object), _dec4 = Prop(), _dec5 = Reflect.metadata("design:type", Object), _dec6 = Prop(), _dec7 = Reflect.metadata("design:type", Number), _dec8 = Prop(), _dec9 = Reflect.metadata("design:type", Number), _dec10 = Prop({
  reflectAsAttribute: false
}), _dec11 = Reflect.metadata("design:type", Number), _dec12 = Watch('axisWidth'), _dec13 = Reflect.metadata("design:paramtypes", []), _dec14 = Prop(), _dec15 = Reflect.metadata("design:type", String), _dec16 = Prop(), _dec17 = Reflect.metadata("design:type", Number), _dec18 = Prop(), _dec19 = Reflect.metadata("design:type", Object), _dec20 = Prop(), _dec21 = Reflect.metadata("design:type", Object), _dec22 = Watch('enumLegendLabels'), _dec23 = Reflect.metadata("design:paramtypes", []), _dec24 = Prop({
  type: String
}), _dec25 = Reflect.metadata("design:type", Object), _dec26 = Prop(), _dec27 = Reflect.metadata("design:type", Object), _dec28 = Watch('visibleLines'), _dec29 = Reflect.metadata("design:paramtypes", []), _dec30 = Prop(), _dec31 = Reflect.metadata("design:type", Object), _dec32 = Watch('visibleEnums'), _dec33 = Reflect.metadata("design:paramtypes", []), _dec34 = Prop(), _dec35 = Reflect.metadata("design:type", Object), _dec36 = Watch('visibleValueAxes'), _dec37 = Reflect.metadata("design:paramtypes", []), _dec38 = Event(), _dec39 = Reflect.metadata("design:type", Object), _dec40 = Prop(), _dec41 = Reflect.metadata("design:type", Object), _dec42 = Prop(), _dec43 = Reflect.metadata("design:type", Number), _dec44 = Prop({
  reflectAsAttribute: false
}), _dec45 = Reflect.metadata("design:type", Object), _dec46 = Prop(), _dec47 = Reflect.metadata("design:type", Boolean), _dec48 = Watch('palette'), _dec49 = Reflect.metadata("design:paramtypes", []), _dec50 = Prop(), _dec51 = Reflect.metadata("design:type", Boolean), _dec52 = State(), _dec53 = Reflect.metadata("design:type", String), _dec(_class = (_class2 = class Plotter extends ColoredDataElement {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "_userDefinedDataSeriesConfigs", []);

    _defineProperty(this, "_userDefinedEnumDataSeriesConfigs", []);

    _defineProperty(this, "_valueAxisMaxTickCount", 20);

    _initializerDefineProperty(this, "axisWidth", _descriptor, this);

    _defineProperty(this, "_timeAxisTitle", '');

    _defineProperty(this, "_historyLength", 3600);

    _initializerDefineProperty(this, "legendLabels", _descriptor2, this);

    _initializerDefineProperty(this, "enumLegendLabels", _descriptor3, this);

    _defineProperty(this, "_expectedSamplingPeriod", 'EveryHundredMillis');

    _defineProperty(this, "_validateSelectedExpectedSamplingPeriod", true);

    _initializerDefineProperty(this, "visibleLines", _descriptor4, this);

    _initializerDefineProperty(this, "visibleEnums", _descriptor5, this);

    _initializerDefineProperty(this, "visibleValueAxes", _descriptor6, this);

    _initializerDefineProperty(this, "visibleTimeRangeChanged", _descriptor7, this);

    _defineProperty(this, "_validateSelectedVisibleTimeRange", true);

    _defineProperty(this, "_selectedVisibleTimeRange", null);

    _defineProperty(this, "_crossWirePosition", 0.9);

    _initializerDefineProperty(this, "toolbarButtons", _descriptor8, this);

    _defineProperty(this, "_play", true);

    _initializerDefineProperty(this, "interactiveLegend", _descriptor9, this);

    _initializerDefineProperty(this, "_showInfoPopup", _descriptor10, this);

    _defineProperty(this, "_samples", new Array());

    _defineProperty(this, "_themeListener", () => {
      this._update();
    });
  }

  /**
   * The configurations used for the data series with decimal values
   */
  get dataSeriesConfigs() {
    return this._userDefinedDataSeriesConfigs;
  }

  set dataSeriesConfigs(newDataSeriesConfigs) {
    this._userDefinedDataSeriesConfigs = ArrayTools.REPLACE_PROPERTIES(this._userDefinedDataSeriesConfigs, newDataSeriesConfigs);

    this._update();
  }
  /**
   * The configurations used for the enum-data series
   */


  get enumDataSeriesConfigs() {
    return this._userDefinedEnumDataSeriesConfigs;
  }

  set enumDataSeriesConfigs(newEnumDataSeriesConfigs) {
    this._userDefinedEnumDataSeriesConfigs = ArrayTools.REPLACE_PROPERTIES(this._userDefinedEnumDataSeriesConfigs, newEnumDataSeriesConfigs);
    this._enumDataSeries = undefined; // must be re-computed

    validateEnumLabels(this.enumLegendLabels, this.enumDataSeriesConfigs);

    this._update();
  }
  /**
   * The maximum number of ticks to be used for any value axis.
   *
   * The number of visible ticks depends on
   * - the currently visible value range,
   * - the height of the value axis and
   * - the font used for the tick values (tick values should not overlap).
   *
   * So it might be that there are less ticks visible than the number specified by this property, but there are never more ticks visible.
   *
   * Set this property to a large value (e. g. 100) to ensure that as many ticks as possible are visible.
   *
   * @default 20
   */


  get valueAxisMaxTickCount() {
    return this._valueAxisMaxTickCount;
  }

  set valueAxisMaxTickCount(value) {
    this._valueAxisMaxTickCount = value;

    this._update();
  }
  /**
   * The width of the value-axis (in rem)
   *
   * @deprecated use {@link axisWidth} instead
   *
   * @default ValueAxisBuilder.AXIS_DEFAULT_WIDTH
   */


  get valueAxisWidth() {
    return this.axisWidth;
  }

  set valueAxisWidth(value) {
    this.axisWidth = value;
  }
  /**
   * The width of the value-axis (in rem)
   *
   * @default ValueAxisBuilder.AXIS_DEFAULT_WIDTH
   */


  axisWidthWatcher() {
    this._update();
  }

  /**
   * The title of the time axis.
   *
   * Blank strings will be treated as if no title is set.
   *
   * @default empty string
   */
  get timeAxisTitle() {
    return this._timeAxisTitle;
  }

  set timeAxisTitle(value) {
    this._timeAxisTitle = value;

    this._update();
  }

  // default is one hour = 3600 seconds

  /**
   * Guaranteed duration in seconds the history stores samples for.
   * The plotter guarantees to store samples for at least this duration (in seconds).
   *
   * @default 3600
   */
  get historyLength() {
    return this._historyLength;
  }

  set historyLength(value) {
    this._historyLength = value;

    this._update();
  }
  /**
   * List of legend-labels used for decimal data-series.
   */


  enumLegendLabelsWatcher() {
    validateEnumLabels(this.enumLegendLabels, this.enumDataSeriesConfigs);
  }

  /**
   * The expected time between two consecutive samples.
   *
   * The history is optimized for certain sampling periods.
   * The value given here helps to adopt the history to your needs.
   * To ensure the best performance pick a sampling period close to the one of your data source.
   * If in doubt, select a sampling period that is smaller than that of your data source.
   * E. g. if you want to add samples every 50 ms to the history choose the sampling period "EveryTenMillis".
   *
   * If you add significantly more samples to the history than expected, those samples will not be lost.
   * However, the history will consume more memory than intended and down-sampling will take more time than it could.
   *
   * If you add significantly less samples to the history than expected, there will not be considerable performance impacts,
   * but you do not use the history to its full potential.
   *
   * Changing the value of this property will also clear the history of the plotter.
   *
   * @default EveryHundredMillis
   */
  get expectedSamplingPeriod() {
    return this._expectedSamplingPeriod;
  }

  set expectedSamplingPeriod(samplingPeriod) {
    const newExpectedSamplingPeriod = sanitizeSamplingPeriod(samplingPeriod, 'EveryHundredMillis');

    if (this._expectedSamplingPeriod !== newExpectedSamplingPeriod) {
      this._expectedSamplingPeriod = newExpectedSamplingPeriod;
      this._validateSelectedExpectedSamplingPeriod = true;
      this.clearHistory();

      this._update();
    }
  }
  /**
   * The indices of the visible lines.
   * If undefined, all lines are visible.
   *
   * Example: `[2, 0, 5]` means that the third, first and sixth line is visible.
   */


  visibleLinesWatcher() {
    this._syncVisibleDataSeriesToLegendActiveState();

    this._update();
  }
  /**
   * The indices of the visible enums.
   * If undefined, all enums are visible.
   *
   * Example: `[2, 0, 5]` means that the third, first and sixth enum is visible.
   */


  visibleEnumsWatcher() {
    this._syncVisibleDataSeriesToLegendActiveState();

    this._update();
  }
  /**
   * The indices of the lines whose value axes are visible.
   * If undefined, the value axes of all lines are visible.
   * Please note that never more than 10 value axes are visible at once.
   * If more than 10 indices are defined only the first 10 will be taken into account.
   *
   * Example: `[2, 0, 5]` means that the value-axis of the third, first and sixth line is visible.
   */


  visibleValueAxesWatcher() {
    this._update();
  }
  /**
   * Emitted if the visible time range has changed
   */


  /**
   * The time range that is currently visible
   *
   * @default null
   */
  get visibleTimeRange() {
    // If the api is ready return the current visible time range.
    if (this._api) {
      return this._api.getVisibleTimeRange();
    } // If the api is not ready yet return the time range selected by the user.


    if (this._selectedVisibleTimeRange) {
      return this._selectedVisibleTimeRange;
    } // If the api is not ready yet and no time range has been selected by the user return an empty time range.


    return {
      start: 0.0,
      end: 0.0
    };
  }

  set visibleTimeRange(timeRange) {
    if (timeRange.start >= timeRange.end) {
      // eslint-disable-next-line
      console.warn(`The selected time range is invalid. The start (${new Date(timeRange.start).toISOString()}) must lie before the end (${new Date(timeRange.end).toISOString()}).
The visible time range will remain unchanged.`); // do not use invalid time range but bail out

      return;
    }

    this._selectedVisibleTimeRange = timeRange;

    this._update();
  }

  // default is 90% of this element's width

  /**
   * The position of the cross wire along the x-axis relative to the width of the plotter.
   *
   * 0 denotes the left edge and 1 denotes the right edge of the plotter.
   *
   * Example: the cross-wire position is 0.7 and the with of the plotter is 1000px wide.
   * Then the location of the cross wire is 700px from the left edge of the plotter and
   * 300px from the right edge of the plotter.
   *
   * @default 0.9
   */
  get crossWirePosition() {
    return this._crossWirePosition;
  }

  set crossWirePosition(value) {
    this._crossWirePosition = value;

    this._update();
  }
  /**
   * The buttons of the toolbar. Set to [] to hide the toolbar completely.
   * The default is ['info', 'separator', 'play', 'pause'].
   */


  /**
   * Stops the automatic feeding of the plotter canvas.
   *
   * Playing also translates the plotter to 'now'.
   *
   * @default false
   */
  get stop() {
    return !this._play;
  }

  set stop(stop) {
    this._play = !stop;

    this._update();
  }
  /**
   * Update style if palette attribute changes
   */


  paletteWatcher() {
    this._update();
  }
  /**
   * If enabled, the legend items can be used to toggle data-series
   */


  addSamples(sample, ...samples) {
    if (Array.isArray(sample)) {
      sample.forEach(s => {
        this._samples.push(s);
      });
    } else {
      this._samples.push(sample);
    }

    samples.forEach(s => {
      this._samples.push(s);
    });

    this._updateSamples();
  }
  /**
   * Removes all samples previously added to the history
   */


  clearHistory() {
    this._samples = [];

    if (this._api) {
      this._api.clearHistory();
    }
  }
  /**
   * Resets zoom and translation
   */


  resetNavigation() {
    if (this._api) {
      this._api.resetView();
    }
  }
  /**
   * Retrieves the current zoom
   *
   * @returns the current zoom.
   */


  getZoom() {
    if (this._api) {
      return this._api.getZoom();
    }

    return {
      scaleX: 1.0,
      scaleY: 1.0
    };
  }
  /**
   * Modifies the current Zoom.
   *
   * @param zoom - the new Zoom
   * @param zoomCenterX - a value in [0..1] that is the x-coordinate of the center of the zoom relative to this element's width (from left to right)
   * @param zoomCenterY - a value in [0..1] that is the y-coordinate of the center of the zoom relative to this element's height (from top to bottom)
   */


  modifyZoom(zoom, zoomCenterX, zoomCenterY) {
    if (this._api) {
      this._api.modifyZoom(zoom, zoomCenterX, zoomCenterY);
    }
  }

  _scaleZoom(scale, zoomDirection) {
    const currentZoom = this.getZoom();
    const targetZoom = {
      scaleX: currentZoom.scaleX,
      scaleY: currentZoom.scaleY
    };

    if (zoomDirection === ZoomDirection.Both || zoomDirection === ZoomDirection.OnlyX) {
      targetZoom.scaleX = targetZoom.scaleX * scale;
    }

    if (zoomDirection === ZoomDirection.Both || zoomDirection === ZoomDirection.OnlyY) {
      targetZoom.scaleY = targetZoom.scaleY * scale;
    }

    this.modifyZoom(targetZoom, 0.5, 0.5);
  }

  _zoomIn(zoomDirection) {
    this._scaleZoom(Math.sqrt(2.0), zoomDirection);
  }

  _zoomOut(zoomDirection) {
    this._scaleZoom(1.0 / Math.sqrt(2.0), zoomDirection);
  }

  _init() {
    var _this$shadowRoot;

    this._syncVisibleDataSeriesToLegendActiveState();

    if (!this._api) {
      return;
    }

    const holder = (_this$shadowRoot = this.shadowRoot) === null || _this$shadowRoot === void 0 ? void 0 : _this$shadowRoot.getElementById('holder');

    if (!holder) {
      return;
    }

    holder.appendChild(this._api.holder);

    this._updateSamples();

    this._update();
  }
  /**
   * Set legend active state depending on visibleLines- and visibleEnums-property
   */


  _syncVisibleDataSeriesToLegendActiveState() {
    const decimalDataSeriesLegendState = createLegendState(0, this.legendLabels.length, this.visibleLines);
    const enumDataSeriesLegendState = createLegendState(this.legendLabels.length, this.enumLegendLabels.length, this.visibleEnums);
    this._legendActiveState = [...decimalDataSeriesLegendState, ...enumDataSeriesLegendState];
  }
  /**
   * See base class
   */


  componentFirstRender() {
    this._init();

    const holder = this.shadowRoot.getElementById('holder');
    holder.addEventListener('VisibleTimeRangeChanged', evt => {
      this.visibleTimeRangeChanged.emit(evt.detail);
    }, {
      passive: true
    });
  }
  /**
   * See base class
   */


  render() {
    var _this$shadowRoot2;

    // recycle holder is needed: holds the actual chart as a child
    let holder = (_this$shadowRoot2 = this.shadowRoot) === null || _this$shadowRoot2 === void 0 ? void 0 : _this$shadowRoot2.getElementById('holder');

    if (!holder) {
      holder = document.createElement('div');
      holder.setAttribute('id', 'holder');
    }

    if (this.legendLabels.length > 0 || this.enumLegendLabels.length > 0) {
      const legendColors = createLegendColors(this);
      const legendSymbols = createLegendSymbols(this);
      const legendLabels = createLegendLabels(this);
      const legendTypes = createLegendTypes(this);
      return html`
        <davinci-legend
          placement="N"
          small-font
          compact
          .interactiveLegend=${this.interactiveLegend}
          .symbols="${legendSymbols}"
          symbol-size="${CssTools.REM2PIXEL(1.5)}"
          toggle-size="${CssTools.REM2PIXEL(.875)}"
          .labels=${legendLabels}
          .palette=${this.palette}
          .colors=${legendColors}
          .types=${legendTypes}
          .legendState=${this._legendActiveState}
          @legendStateChanged=${this._handleLegendStateChanged}>
          <div class="inner">
            ${holder}
            ${this._renderToolbar()}
          </div>
        </davinci-legend>
        ${this._renderInfoPopup()}
      `;
    } else {
      return html`
        <div class="inner">
          ${holder}
          ${this._renderToolbar()}
        </div>
        ${this._renderInfoPopup()}
      `;
    }
  }

  _renderToolbar() {
    if (this.toolbarButtons.length === 0) {
      return html``;
    }

    return html`
      <davinci-plotter-toolbar .buttons="${this.toolbarButtons}" .play="${!this.stop}" @buttonClick=${this._onToolbarButtonClick}></davinci-plotter-toolbar>
    `;
  }

  _renderInfoPopup() {
    if (this._showInfoPopup === 'hide') {
      return html``;
    }

    return html`
      <davinci-plotter-info-popup .touch=${this._showInfoPopup === 'showTouch'} @close=${this._onInfoPopupClose}></davinci-plotter-info-popup>
    `;
  }

  _onToolbarButtonClick(customEvent) {
    const {
      button,
      event
    } = customEvent.detail;

    switch (button) {
      case PlotterToolbarButton.Play:
        this.stop = false;
        break;

      case PlotterToolbarButton.Pause:
        this.stop = true;
        break;

      case PlotterToolbarButton.PlayPause:
        this.stop = !this.stop;
        break;

      case PlotterToolbarButton.Reset:
        this.resetNavigation();
        break;

      case PlotterToolbarButton.ZoomIn:
        this._zoomIn(ZoomDirection.Both);

        break;

      case PlotterToolbarButton.ZoomOut:
        this._zoomOut(ZoomDirection.Both);

        break;

      case PlotterToolbarButton.Info:
        // We need to wait until the browser has totally processed the pointer-event
        // before we trigger the rendering process of the info-popup. Otherwise the
        // info-popup will also process the event and close itself.
        window.setTimeout(() => {
          this._showInfoPopup = event.pointerType === 'mouse' ? 'showMouse' : 'showTouch';
        }, 0);
        break;

      default:
        // eslint-disable-next-line
        console.error(`unknown toolbar-button type <${button}>`);
        break;
    }
  }

  _onInfoPopupClose() {
    this._showInfoPopup = 'hide';
  }

  componentConnected() {
    super.componentConnected();
    ThemeService.GET_INSTANCE().addListener(this._themeListener);
    this._api = QuickChart.createTimeLineChart(); // this could be a reattach without a following call for componentFirstRender -> reestablish QuickChart API

    this._init();
  }

  componentDisconnected() {
    super.componentDisconnected();
    ThemeService.GET_INSTANCE().removeListener(this._themeListener);
    this._decimalDataSeries = undefined; // must be recomputed

    this._enumDataSeries = undefined; // must be recomputed
    // We have been detached from the DOM -> clean up

    if (this._api) {
      var _this$shadowRoot3, _this$shadowRoot3$get;

      (_this$shadowRoot3 = this.shadowRoot) === null || _this$shadowRoot3 === void 0 ? void 0 : (_this$shadowRoot3$get = _this$shadowRoot3.getElementById('holder')) === null || _this$shadowRoot3$get === void 0 ? void 0 : _this$shadowRoot3$get.removeChild(this._api.holder);

      this._api.dispose();
    }

    delete this._api;
  }

  _validateExpectedSamplingPeriod(samples) {
    if (this._validateSelectedExpectedSamplingPeriod) {
      if (samples.length > 1) {
        validateExpectedSamplingPeriod(this.expectedSamplingPeriod, samples);
        this._validateSelectedExpectedSamplingPeriod = false;
      }
    }
  }

  _validateVisibleTimeRange(timeRange) {
    if (this._validateSelectedVisibleTimeRange) {
      if (timeRange !== null) {
        validateVisibleTimeRange(timeRange, this.expectedSamplingPeriod);
        this._validateSelectedVisibleTimeRange = false;
      }
    }
  }

  _updateSamples() {
    if (this._api === undefined) {
      return;
    }

    this._samples = sanitizeSamples(this._samples);

    if (this._samples.length === 0) {
      return;
    }

    this._validateExpectedSamplingPeriod(this._samples);

    if (this._updateDataSeries(this._samples)) {
      // update everything if the data-series configuration has changed
      this._update();
    }

    try {
      this._api.addSamples(this._samples);
    } finally {
      // Ensure that the samples are cleared - even if an exception is thrown
      this._samples = [];
    }
  }

  _updateDataSeries(samples) {
    if (samples.length === 0) {
      // The data-series configuration is computed from the samples. No samples means we cannot update the configuration.
      return false;
    } // this._samples must be sanitized at this point


    const lastSample = samples[samples.length - 1];
    let update = false;

    if (this._updateDecimalDataSeriesFromSample(lastSample)) {
      update = true;
    }

    if (this._updateEnumDataSeriesFromSample(lastSample)) {
      update = true;
    }

    if (update) {
      var _this$_decimalDataSer, _this$_enumDataSeries;

      // eslint-disable-next-line
      console.log('the data-series configuration must be updated; the history will likely be cleared'); // Notify QuickChart about the data series that will be stored into the history.

      this._api.setDataSeries((_this$_decimalDataSer = this._decimalDataSeries) !== null && _this$_decimalDataSer !== void 0 ? _this$_decimalDataSer : [], (_this$_enumDataSeries = this._enumDataSeries) !== null && _this$_enumDataSeries !== void 0 ? _this$_enumDataSeries : []);
    }

    return update;
  }

  _updateDecimalDataSeriesFromSample(sample) {
    var _this$_decimalDataSer2, _this$_decimalDataSer3;

    const newDecimalDataSeriesCount = getDecimalDataSeriesCount(sample);
    const oldDecimalDataSeriesCount = (_this$_decimalDataSer2 = (_this$_decimalDataSer3 = this._decimalDataSeries) === null || _this$_decimalDataSer3 === void 0 ? void 0 : _this$_decimalDataSer3.length) !== null && _this$_decimalDataSer2 !== void 0 ? _this$_decimalDataSer2 : 0;

    if (newDecimalDataSeriesCount === oldDecimalDataSeriesCount) {
      return false;
    }

    this._decimalDataSeries = computeDecimalDataSeriesFromSample(sample);
    return true;
  }

  _updateEnumDataSeriesFromSample(sample) {
    var _this$_enumDataSeries2, _this$_enumDataSeries3;

    const newEnumDataSeriesCount = getEnumDataSeriesCount(sample);
    const oldEnumDataSeriesCount = (_this$_enumDataSeries2 = (_this$_enumDataSeries3 = this._enumDataSeries) === null || _this$_enumDataSeries3 === void 0 ? void 0 : _this$_enumDataSeries3.length) !== null && _this$_enumDataSeries2 !== void 0 ? _this$_enumDataSeries2 : 0;

    if (newEnumDataSeriesCount === oldEnumDataSeriesCount) {
      return false;
    }

    this._enumDataSeries = computeEnumDataSeries(this.enumDataSeriesConfigs, this.enumLegendLabels, sample);
    return true;
  }

  _updateEnumDataSeries() {
    var _this$_decimalDataSer4, _this$_enumDataSeries4;

    if (this._enumDataSeries !== undefined) {
      return;
    }

    this._enumDataSeries = computeEnumDataSeries(this.enumDataSeriesConfigs, this.enumLegendLabels); // eslint-disable-next-line

    console.log('the data-series configuration must be updated; the history will likely be cleared');

    this._api.setDataSeries((_this$_decimalDataSer4 = this._decimalDataSeries) !== null && _this$_decimalDataSer4 !== void 0 ? _this$_decimalDataSer4 : [], (_this$_enumDataSeries4 = this._enumDataSeries) !== null && _this$_enumDataSeries4 !== void 0 ? _this$_enumDataSeries4 : []);
  }
  /**
   * Call this function every time a plotter-related property changes
   */


  _update() {
    var _this$shadowRoot4, _this$_enumDataSeries5, _this$_enumDataSeries6, _this$visibleLines, _this$visibleEnums, _this$visibleValueAxe, _this$dataSeriesConfi;

    if (this._api === undefined) {
      return;
    }

    this._updateEnumDataSeries();

    const timeLineChartData = {
      historySettings: {
        expectedSamplingPeriod: this._expectedSamplingPeriod,
        minGapSizeFactor: 10.0,
        // default value
        guaranteedHistoryLength: this._historyLength
      },
      play: this._play
    };

    this._api.setData(timeLineChartData);

    const host = (_this$shadowRoot4 = this.shadowRoot) === null || _this$shadowRoot4 === void 0 ? void 0 : _this$shadowRoot4.host;

    if (!host) {
      return;
    }

    const fontFamily = CssTools.GET_COMPUTED_FONT_FAMILY(host);

    this._validateVisibleTimeRange(this._selectedVisibleTimeRange);

    const lineUnits = this.dataSeriesConfigs.map(dataSeriesConfig => dataSeriesConfig.unit || '');
    const dataSeriesFormat = this.dataSeriesConfigs.map(dataSeriesConfig => {
      var _dataSeriesConfig$sho;

      const shorthandLabels = (_dataSeriesConfig$sho = dataSeriesConfig.shorthandLabels) !== null && _dataSeriesConfig$sho !== void 0 ? _dataSeriesConfig$sho : defaultShorthandLabels;
      const decimalPlaces = dataSeriesConfig.decimalPlaces;
      return decimalPlaces === undefined ? createValueFormatMinMax(shorthandLabels, 0, 4) : createValueFormat(shorthandLabels, decimalPlaces);
    });
    const lineStyles = computeLineStyles(this.dataSeriesConfigs, this.palette);
    const timeLineChartStyle = {
      showToolbar: false,
      showMouseWheelModifierHint: false,
      visibleTimeRange: this._selectedVisibleTimeRange,
      crossWirePosition: this._crossWirePosition,
      decimalDataSeriesStyles: computeDecimalDataSeriesStyles(this.dataSeriesConfigs, fontFamily, lineStyles),
      enumDataSeriesStyles: computeEnumDataSeriesStyles(this.enumDataSeriesConfigs, this.palette, (_this$_enumDataSeries5 = (_this$_enumDataSeries6 = this._enumDataSeries) === null || _this$_enumDataSeries6 === void 0 ? void 0 : _this$_enumDataSeries6.length) !== null && _this$_enumDataSeries5 !== void 0 ? _this$_enumDataSeries5 : 0),
      lineStyles: lineStyles,
      visibleLines: (_this$visibleLines = this.visibleLines) !== null && _this$visibleLines !== void 0 ? _this$visibleLines : [-1],
      visibleEnumStripes: (_this$visibleEnums = this.visibleEnums) !== null && _this$visibleEnums !== void 0 ? _this$visibleEnums : [-1],
      visibleValueAxes: (_this$visibleValueAxe = this.visibleValueAxes) !== null && _this$visibleValueAxe !== void 0 ? _this$visibleValueAxe : [-1],
      valueAxesGap: CssTools.REM2PIXEL(1.0),
      valueAxesBackground: resolveCssColor('var(--davinci-color-background-elements-overlay)'),
      crossWireDecimalsFormat: {
        format(index, value, locale) {
          var _lineUnits, _dataSeriesFormat, _dataSeriesFormat2;

          const lineUnit = (_lineUnits = lineUnits[index % lineUnits.length]) !== null && _lineUnits !== void 0 ? _lineUnits : '';
          const formattedValue = (_dataSeriesFormat = (_dataSeriesFormat2 = dataSeriesFormat[index % dataSeriesFormat.length]) === null || _dataSeriesFormat2 === void 0 ? void 0 : _dataSeriesFormat2.call(dataSeriesFormat, value, locale)) !== null && _dataSeriesFormat !== void 0 ? _dataSeriesFormat : value.toFixed(2);
          return lineUnit ? `${formattedValue} ${lineUnit}` : formattedValue;
        }

      },
      enumsBackgroundColor: resolveCssColor('var(--davinci-color-background-elements-6)')
    };
    timeLineChartStyle.crossWireFont = createTooltipFont(fontFamily);
    timeLineChartStyle.crossWireDecimalsLabelBoxStyles = createTooltipDecimalsBoxStyles(timeLineChartStyle.lineStyles.map(lineStyle => lineStyle.lineStyle.color));
    timeLineChartStyle.crossWireEnumsLabelBoxStyles = [createTooltipEnumsBoxStyles()]; // just create one element - this will be used for all enums

    timeLineChartStyle.crossWireStyle = {
      wireColor: resolveCssColor('var(--davinci-color-text-on-background-elements-4)'),
      wireWidth: 1
    }; // reset the user settings

    this._selectedVisibleTimeRange = null;
    const timeAxisBuilder = new TimeAxisBuilder();
    timeAxisBuilder.fontFamily = fontFamily;
    timeAxisBuilder.title = this.timeAxisTitle;
    timeLineChartStyle.timeAxisStyle = timeAxisBuilder.build(); // If one value axis has a title all value axes should behave as if they had a title.
    // This ensures that all value axes have the same width.

    const valueAxesHaveTitles = ((_this$dataSeriesConfi = this.dataSeriesConfigs) === null || _this$dataSeriesConfi === void 0 ? void 0 : _this$dataSeriesConfi.findIndex(dataSeriesConfig => {
      var _dataSeriesConfig$uni, _dataSeriesConfig$uni2;

      return ((_dataSeriesConfig$uni = dataSeriesConfig.unit) === null || _dataSeriesConfig$uni === void 0 ? void 0 : (_dataSeriesConfig$uni2 = _dataSeriesConfig$uni.trim()) === null || _dataSeriesConfig$uni2 === void 0 ? void 0 : _dataSeriesConfig$uni2.length) > 0;
    })) !== -1; // Beware that we cannot use the default tick length and tick-label gap for
    // the plotter because the plotter is the only chart whose value axes have
    // visible tick marks.

    const valueAxisBuilder = new ValueAxisBuilder();
    valueAxisBuilder.fontFamily = fontFamily;
    valueAxisBuilder.horizontal = false;
    valueAxisBuilder.tickLength = 0.5; // set explicitly and do not use default value

    valueAxisBuilder.tickLabelGap = 0.5; // set explicitly and do not use default value

    valueAxisBuilder.title = valueAxesHaveTitles ? 'X' : '';
    valueAxisBuilder.maxTickCount = this.valueAxisMaxTickCount;
    valueAxisBuilder.axisWidth = this.axisWidth;
    valueAxisBuilder.shorthandLabels = defaultShorthandLabels; // will be ignored by quickchart

    valueAxisBuilder.decimalPlaces = undefined; // will be ignored by quickchart

    timeLineChartStyle.valueAxesStyle = valueAxisBuilder.build(); // The following values are automatically computed if set to null

    timeLineChartStyle.valueAxesStyle.title = null;
    timeLineChartStyle.valueAxesStyle.axisLineColor = null;
    timeLineChartStyle.valueAxesStyle.tickLabelColor = null;
    timeLineChartStyle.enumAxisStyle = {
      axisSize: timeLineChartStyle.valueAxesStyle.axisSize,
      axisLineColor: timeLineChartStyle.timeAxisStyle.axisLineColor,
      axisLineWidth: timeLineChartStyle.timeAxisStyle.axisLineWidth,
      tickFont: timeLineChartStyle.timeAxisStyle.tickFont,
      labelWrapMode: 'IfNecessary',
      tickLength: timeLineChartStyle.valueAxesStyle.tickLength,
      tickLabelColor: timeLineChartStyle.timeAxisStyle.tickLabelColor,
      tickLabelGap: timeLineChartStyle.valueAxesStyle.tickLabelGap
    };

    this._api.setStyle(timeLineChartStyle);
  }

  _handleLegendStateChanged(e) {
    // First compute the visible indices then update the properties to prevent cyclic updates.
    const newLegendActiveState = e.detail;
    const activeLegendItemIndices = computeActiveLegendItemIndices(newLegendActiveState);
    const visibleLines = activeLegendItemIndices.filter(index => index < this.legendLabels.length);
    const visibleEnums = activeLegendItemIndices.filter(index => index >= this.legendLabels.length).map(index => index - this.legendLabels.length);
    this._legendActiveState = newLegendActiveState;
    this.visibleLines = visibleLines;
    this.visibleValueAxes = visibleLines;
    this.visibleEnums = visibleEnums;
  }

}, (_applyDecoratedDescriptor(_class2.prototype, "dataSeriesConfigs", [_dec2, _dec3], Object.getOwnPropertyDescriptor(_class2.prototype, "dataSeriesConfigs"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "enumDataSeriesConfigs", [_dec4, _dec5], Object.getOwnPropertyDescriptor(_class2.prototype, "enumDataSeriesConfigs"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "valueAxisMaxTickCount", [_dec6, _dec7], Object.getOwnPropertyDescriptor(_class2.prototype, "valueAxisMaxTickCount"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "valueAxisWidth", [_dec8, _dec9], Object.getOwnPropertyDescriptor(_class2.prototype, "valueAxisWidth"), _class2.prototype), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "axisWidth", [_dec10, _dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return ValueAxisBuilder.AXIS_DEFAULT_WIDTH;
  }
}), _applyDecoratedDescriptor(_class2.prototype, "axisWidthWatcher", [_dec12, _dec13], Object.getOwnPropertyDescriptor(_class2.prototype, "axisWidthWatcher"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "timeAxisTitle", [_dec14, _dec15], Object.getOwnPropertyDescriptor(_class2.prototype, "timeAxisTitle"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "historyLength", [_dec16, _dec17], Object.getOwnPropertyDescriptor(_class2.prototype, "historyLength"), _class2.prototype), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "legendLabels", [_dec18, _dec19], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "enumLegendLabels", [_dec20, _dec21], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _applyDecoratedDescriptor(_class2.prototype, "enumLegendLabelsWatcher", [_dec22, _dec23], Object.getOwnPropertyDescriptor(_class2.prototype, "enumLegendLabelsWatcher"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "expectedSamplingPeriod", [_dec24, _dec25], Object.getOwnPropertyDescriptor(_class2.prototype, "expectedSamplingPeriod"), _class2.prototype), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "visibleLines", [_dec26, _dec27], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "visibleLinesWatcher", [_dec28, _dec29], Object.getOwnPropertyDescriptor(_class2.prototype, "visibleLinesWatcher"), _class2.prototype), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "visibleEnums", [_dec30, _dec31], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "visibleEnumsWatcher", [_dec32, _dec33], Object.getOwnPropertyDescriptor(_class2.prototype, "visibleEnumsWatcher"), _class2.prototype), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "visibleValueAxes", [_dec34, _dec35], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "visibleValueAxesWatcher", [_dec36, _dec37], Object.getOwnPropertyDescriptor(_class2.prototype, "visibleValueAxesWatcher"), _class2.prototype), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "visibleTimeRangeChanged", [_dec38, _dec39], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "visibleTimeRange", [_dec40, _dec41], Object.getOwnPropertyDescriptor(_class2.prototype, "visibleTimeRange"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "crossWirePosition", [_dec42, _dec43], Object.getOwnPropertyDescriptor(_class2.prototype, "crossWirePosition"), _class2.prototype), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "toolbarButtons", [_dec44, _dec45], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [PlotterToolbarButton.Info, PlotterToolbarButton.Separator, PlotterToolbarButton.Play, PlotterToolbarButton.Pause];
  }
}), _applyDecoratedDescriptor(_class2.prototype, "stop", [_dec46, _dec47], Object.getOwnPropertyDescriptor(_class2.prototype, "stop"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "paletteWatcher", [_dec48, _dec49], Object.getOwnPropertyDescriptor(_class2.prototype, "paletteWatcher"), _class2.prototype), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, "interactiveLegend", [_dec50, _dec51], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class2.prototype, "_showInfoPopup", [_dec52, _dec53], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 'hide';
  }
})), _class2)) || _class);
/**
 * The config of a data series in the Plotter
 */

var ZoomDirection;

(function (ZoomDirection) {
  ZoomDirection[ZoomDirection["OnlyX"] = 0] = "OnlyX";
  ZoomDirection[ZoomDirection["OnlyY"] = 1] = "OnlyY";
  ZoomDirection[ZoomDirection["Both"] = 2] = "Both";
})(ZoomDirection || (ZoomDirection = {}));
